/* tslint:disable */
/* eslint-disable */
/**
 * MinSide.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UserIdentityOrigin } from './UserIdentityOrigin';
import {
    UserIdentityOriginFromJSON,
    UserIdentityOriginFromJSONTyped,
    UserIdentityOriginToJSON,
    UserIdentityOriginToJSONTyped,
} from './UserIdentityOrigin';
import type { UserType } from './UserType';
import {
    UserTypeFromJSON,
    UserTypeFromJSONTyped,
    UserTypeToJSON,
    UserTypeToJSONTyped,
} from './UserType';

/**
 * 
 * @export
 * @interface VerifiedUserResponse
 */
export interface VerifiedUserResponse {
    /**
     * 
     * @type {string}
     * @memberof VerifiedUserResponse
     */
    userId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerifiedUserResponse
     */
    givenName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerifiedUserResponse
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerifiedUserResponse
     */
    displayName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof VerifiedUserResponse
     */
    email?: string | null;
    /**
     * 
     * @type {UserIdentityOrigin}
     * @memberof VerifiedUserResponse
     */
    identityOrigin?: UserIdentityOrigin;
    /**
     * 
     * @type {boolean}
     * @memberof VerifiedUserResponse
     */
    isIdPortenUser?: boolean;
    /**
     * 
     * @type {UserType}
     * @memberof VerifiedUserResponse
     */
    userType?: UserType;
}



/**
 * Check if a given object implements the VerifiedUserResponse interface.
 */
export function instanceOfVerifiedUserResponse(value: object): value is VerifiedUserResponse {
    return true;
}

export function VerifiedUserResponseFromJSON(json: any): VerifiedUserResponse {
    return VerifiedUserResponseFromJSONTyped(json, false);
}

export function VerifiedUserResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifiedUserResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] === undefined ? undefined : json['userId'] === null ? null : json['userId'],
        'givenName': json['givenName'] === undefined ? undefined : json['givenName'] === null ? null : json['givenName'],
        'surname': json['surname'] === undefined ? undefined : json['surname'] === null ? null : json['surname'],
        'displayName': json['displayName'] === undefined ? undefined : json['displayName'] === null ? null : json['displayName'],
        'email': json['email'] === undefined ? undefined : json['email'] === null ? null : json['email'],
        'identityOrigin': json['identityOrigin'] == null ? undefined : UserIdentityOriginFromJSON(json['identityOrigin']),
        'isIdPortenUser': json['isIdPortenUser'] == null ? undefined : json['isIdPortenUser'],
        'userType': json['userType'] == null ? undefined : UserTypeFromJSON(json['userType']),
    };
}

export function VerifiedUserResponseToJSON(json: any): VerifiedUserResponse {
    return VerifiedUserResponseToJSONTyped(json, false);
}

export function VerifiedUserResponseToJSONTyped(value?: VerifiedUserResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'givenName': value['givenName'],
        'surname': value['surname'],
        'displayName': value['displayName'],
        'email': value['email'],
        'identityOrigin': UserIdentityOriginToJSON(value['identityOrigin']),
        'isIdPortenUser': value['isIdPortenUser'],
        'userType': UserTypeToJSON(value['userType']),
    };
}

